import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumbs } from '../../models/class/common/BreadCrumbs';
import { EncryptedService } from '../../services/common/encrypted.services';
import { IBreadCrumbs } from 'src/app/models/interfaces/common/IBreadcrumbs';

@Injectable()

export class BreadCrumbsService {

  public routes: Array<IBreadCrumbs> = [];

  constructor(
    private _encrypted: EncryptedService,
    private route: Router
  ) { }

  reset(breadCrumbsName: string) {
    sessionStorage.removeItem('breadCrumbs');

    const current_url = window.location.href
      .toString()
      .split(window.location.host)[1];
    this.MyBreadCrumbs(current_url, breadCrumbsName);
  }

  resetModule() {
    let breadCrumb: any = this._encrypted.decrypted(sessionStorage.getItem('breadCrumbs'));
    breadCrumb = JSON.parse(breadCrumb);

    sessionStorage.removeItem('breadCrumbs');

    // breadCrumb.splice(1, breadCrumb.length - 1);

    this.MyBreadCrumbs(breadCrumb[0].url, breadCrumb[0].name);

    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      const split = key.split('');
      split.forEach(element => {
        if (element === '/') {
          sessionStorage.removeItem(key);
        }
      });
    }

    // const breadCrumbsStringify = JSON.stringify(breadCrumb);
    // sessionStorage.setItem('breadCrumbs', this._encrypted.encrypted(breadCrumbsStringify));
  }

  GetPrevious() {
    let currentBreadCrumbs: Array<BreadCrumbs> = new Array<BreadCrumbs>();
    if (
      sessionStorage.getItem('breadCrumbs') !== null &&
      sessionStorage.getItem('breadCrumbs') !== ''
    ) {
      currentBreadCrumbs = JSON.parse(
        this._encrypted.decrypted(sessionStorage.getItem('breadCrumbs'))
      );
      let BreadCrumbsSize = currentBreadCrumbs.length;
      BreadCrumbsSize = BreadCrumbsSize >= 2 ? BreadCrumbsSize : 2;
      const finalUrl = currentBreadCrumbs[BreadCrumbsSize - 2].url;
      return finalUrl.split('/#').join('');
    }
    return null;
  }

  // currentBreadCrumbs?: Array<BreadCrumbs>
  MyBreadCrumbs(url: string, componentName: string): void {

    // if (routerChangeEmit === undefined) {
    //   OnRouteChange.subscribe((routes: any) => {
    //     this.routes = routes;
    //   });
    // }

    let currentBreadCrumbs: Array<BreadCrumbs> = new Array<BreadCrumbs>();

    if (
      sessionStorage.getItem('breadCrumbs') !== null &&
      sessionStorage.getItem('breadCrumbs') !== ''
    ) {
      const aux = this._encrypted.decrypted(
        sessionStorage.getItem('breadCrumbs')
      );
      currentBreadCrumbs = JSON.parse(aux);
    }

    // Se comprueba si es la primera entrada de la cadena de Bread Crumbs
    if (currentBreadCrumbs === undefined && currentBreadCrumbs.length <= 0) {
      currentBreadCrumbs = new Array<BreadCrumbs>();
      // tslint:disable-next-line:no-var-keyword
      const a = new BreadCrumbs();

      a.name = componentName;
      a.url = url;
      a.active = true;

      currentBreadCrumbs.push(a);
    } else {
      const isrepeated = currentBreadCrumbs.findIndex(
        x => x.name === componentName
      );

      if (isrepeated === -1) {
        // La etiqueta del componente no se encuentra repetido por lo tanto se se ingresa
        // tslint:disable-next-line:no-shadowed-variable
        const a = new BreadCrumbs();

        a.name = componentName;
        a.url = url;
        a.active = true;

        // Se actualiza la clase 'active' en la cadena de Bread Crumbs
        if (currentBreadCrumbs.length > 0) {
          for (let i = 0; i < currentBreadCrumbs.length; i++) {
            currentBreadCrumbs[i].active = false;
          }
        }

        // Se ingresa la nueva entrada
        currentBreadCrumbs.push(a);
      } else {
        // En el caso de estar repetida la etiqueta del componente se chequea que la url sea identica

        // tslint:disable-next-line:max-line-length
        // En este caso etiqueta repetida y url identico se actualiza la cadena de Bread Crumbs cortandola hasta la entrada actual como el final
        if (currentBreadCrumbs[isrepeated].url === url) {
          currentBreadCrumbs.splice(isrepeated + 1);
          currentBreadCrumbs[currentBreadCrumbs.length - 1].active = true;

          // En este caso etiqueta repetida pero diferente url se procede a revisar y se intenta modificar
        } else {
          // detectUrlChange: es una variable para el caso especial donde se sabe que
          // se esta cambiando un id de
          // la vista actual y no se desea actualizar el BreadCrums debido a esto se interfiere con el proceso.
          // isOwner = this.IsOwnerComponent(currentBreadCrumbs[isrepeated].url.toString(), url.toString());
          // Si no existe entonces ¡¡
          // SI ES EL COMPONENTE PROPIETARIO DEL URL QUE SE INTENTA MODIFICAR por lo tanto si se modifica la cadena de Bread Crumbs!!
          currentBreadCrumbs.splice(isrepeated + 1);
          currentBreadCrumbs[isrepeated].url = url;
          currentBreadCrumbs[isrepeated].active = true;
        }
      }
    }

    const breadCrumbsStringify = JSON.stringify(currentBreadCrumbs);
    sessionStorage.setItem(
      'breadCrumbs',
      this._encrypted.encrypted(breadCrumbsStringify)
    );
    // routerChangeEmit.next(currentBreadCrumbs);

  }

}
